import Cookies from 'js-cookie';
import { localize } from 'mixins/helpers';

const bvi = (options: Record<string, any>, props: any) => {
    const default_setting = {
        ...options,
        bvi_target: '.bvi-open',
        bvi_theme: 'white',
        bvi_font: 'arial',
        bvi_font_size: 16,
        bvi_letter_spacing: 'normal',
        bvi_line_height: 'normal',
        bvi_images: true,
        bvi_reload: false,
        bvi_fixed: true,
        bvi_tts: false,
        bvi_flash_iframe: true,
        bvi_hide: false,
    };

    const detectIE = () => {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');
        const edge = ua.indexOf('Edge/');

        if (msie > 0) {
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        if (trident > 0) {
            const rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        if (edge > 0) {
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        return false;
    };

    const versionIE = detectIE();
    const selector = default_setting.bvi_target;
    let check_bvi_theme;
    let check_bvi_font;
    let check_bvi_letter_spacing;
    let check_bvi_line_height;
    let check_bvi_font_size;
    let check_bvi_images;
    let check_bvi_fixed;
    let check_bvi_tts;
    let check_bvi_flash_iframe;
    let check_bvi_hide;
    const bvi_tts_synth = window.speechSynthesis;
    const bvi_tts_support_browser = bvi_tts_synth !== undefined;
    // const sm = 576;
    // const md = 768;
    const lg = 992;
    // const xl = 1200;
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;

    if (bvi_tts_support_browser) {
        setInterval(() => {
            if (!bvi_tts_synth.speaking) {
                document
                    .querySelectorAll('.bvi-tts-play')
                    .forEach((i) => i.classList.remove('disabled'));
                document
                    .querySelectorAll('.bvi-tts-pause')
                    .forEach((i) => i.classList.add('disabled'));
                document
                    .querySelectorAll('.bvi-tts-resume')
                    .forEach((i) => i.classList.add('disabled'));
                document
                    .querySelectorAll('.bvi-tts-stop')
                    .forEach((i) => i.classList.add('disabled'));
            }
        }, 1000);
        // console.log('Bvi console: Чтение речи поддерживается в данной браузере');
    } else {
        // console.log('Bvi console: Чтение речи не поддерживается в данном браузере');
    }

    if (Cookies.get('bvi-theme') == 'green') {
        document.querySelector('html').classList.add('bvi-theme-green');
    }
    if (Cookies.get('bvi-theme') == 'white') {
        document.querySelector('html').classList.add('bvi-theme-white');
    }
    if (Cookies.get('bvi-theme') == 'black') {
        document.querySelector('html').classList.add('bvi-theme-black');
    }
    if (Cookies.get('bvi-theme') == 'brown') {
        document.querySelector('html').classList.add('bvi-theme-brown');
    }
    if (Cookies.get('bvi-theme') == 'blue') {
        document.querySelector('html').classList.add('bvi-theme-blue');
    }

    window.addEventListener('resize', () => {
        const width_resize = window.innerWidth > 0 ? window.innerWidth : screen.width;

        if (width_resize >= lg) {
            document
                .querySelectorAll('.bvi-panel-container')
                .forEach((i: HTMLElement) => (i.style.display = 'block'));
            document
                .querySelectorAll('.bvi-panel-container')
                .forEach((i: HTMLElement) => (i.style.display = 'block'));
        }

        if (width_resize <= lg) {
            document
                .querySelectorAll('.bvi-panel-container')
                .forEach((i) => i.classList.remove('bvi-container'));
            document
                .querySelectorAll('.bvi-panel-container')
                .forEach((i) => i.classList.remove('bvi-container-fluid'));
        } else {
            document
                .querySelectorAll('.bvi-panel-container')
                .forEach((i) => i.classList.remove('bvi-container-fluid'));
            document
                .querySelectorAll('.bvi-panel-container')
                .forEach((i) => i.classList.remove('bvi-container'));
        }
    });

    const bvi_tts_speak = (text: string) => {
        if (Cookies.get('bvi-tts') === 'true' && bvi_tts_support_browser) {
            bvi_tts_synth.cancel();
            const voices = bvi_tts_synth.getVoices();
            const chunkLength = 120;
            const pattRegex = new RegExp(
                '^[\\s\\S]{' +
                    Math.floor(chunkLength / 2) +
                    ',' +
                    chunkLength +
                    '}[.!?,]{1}|^[\\s\\S]{1,' +
                    chunkLength +
                    '}$|^[\\s\\S]{1,' +
                    chunkLength +
                    '} '
            );
            const $array = [];
            let $text = text;

            while ($text.length > 0) {
                const matchText = $text.match(pattRegex);
                if (matchText) {
                    $array.push(matchText[0]);
                }
                $text = $text.substring($array[$array.length - 1].length);
            }

            $array.forEach((item) => {
                const speechUtterance = new SpeechSynthesisUtterance(item.trim());
                speechUtterance.volume = 1;
                speechUtterance.rate = 1;
                speechUtterance.pitch = 1;
                speechUtterance.lang = 'ru-RU';

                speechUtterance.onstart = () => {
                    // console.log(speechUtterance);
                    // console.log('Start called for: ' + event.utterance.text + '-' + event.charIndex);
                };

                speechUtterance.onend = () => {
                    // console.log(event.name + ' end ' + event.elapsedTime + ' milliseconds.');
                };

                speechUtterance.onpause = () => {
                    // console.log(event.name + ' pause ' + event.elapsedTime + ' milliseconds.');
                };

                speechUtterance.onresume = () => {
                    // console.log(event.name + ' resume ' + event.elapsedTime + ' milliseconds.');
                };

                speechUtterance.onboundary = () => {
                    /*
            var world = bvi_getWordAt(event.utterance.text, event.charIndex);
            var src_str = $(id).text();
            var term = world.replace(/(\s+)/, "(<[^>]+>)*$1(<[^>]+>)*");
            var pattern = new RegExp("(" + term + ")", "gi");
            src_str = src_str.replace(pattern, "<mark>$1</mark>");
            src_str = src_str.replace(/(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/, "$1</mark>$2<mark>$4");
            $(id).html(src_str);
            console.log(event.utterance.text);
            */
                };

                voices.forEach((voice) => {
                    if (voice.lang === 'ru-RU' && voice.voiceURI === 'Google русский') {
                        speechUtterance.voice = voice;
                        // speechUtterance.voiceURI = voice.voiceURI;
                    } else if (
                        voice.lang === 'ru-RU' &&
                        voice.voiceURI === 'Microsoft Irina Desktop - Russian'
                    ) {
                        speechUtterance.voice = voice;
                        // (window as any).speechUtterance.voiceURI = voice.voiceURI;
                    } else if (
                        voice.lang === 'ru-RU' &&
                        voice.voiceURI ===
                            'urn:moz-tts:sapi:Microsoft Irina Desktop - Russian?ru-RU'
                    ) {
                        speechUtterance.voice = voice;
                        // (window as any).speechUtterance.voiceURI = voice.voiceURI;
                    } else if (
                        voice.lang === 'ru-RU' &&
                        voice.voiceURI === 'com.apple.speech.synthesis.voice.yuri'
                    ) {
                        speechUtterance.voice = voice;
                        // (window as any).speechUtterance.voiceURI = voice.voiceURI;
                    }
                });

                bvi_tts_synth.speak(speechUtterance);
            });
        }
    };

    // const bvi_getWordAt = (str: string, pos: number) => {
    //     str = String(str);
    //     pos = Number(pos) >>> 0;
    //     const left = str.slice(0, pos + 1).search(/\S+$/),
    //         right = str.slice(pos).search(/\s/);
    //     if (right < 0) {
    //         return str.slice(left);
    //     }
    //     return str.slice(left, right + pos);
    // };

    const set = (data: string, set_cookies: string, set_cookies_data: any) => {
        Cookies.set(set_cookies, set_cookies_data, { path: '/', expires: 1 });
        const setCookie = Cookies.get(set_cookies);
        if (setCookie) {
            document.querySelectorAll('.bvi-body').forEach((i) => i.setAttribute(data, setCookie));
        }
        get_image();
    };

    const bvi_tts_player = () => {
        let bvi_tts_text_id;
        const bvi_tts_voice_target = document.querySelectorAll('.bvi-tts');

        document.querySelectorAll('.bvi-tts-link').forEach((i) => i.remove());
        document.querySelectorAll('.bvi-tts-text').forEach((i) => {
            i.outerHTML = i.innerHTML;
        });

        if (Cookies.get('bvi-tts') === 'true' && bvi_tts_support_browser) {
            if (bvi_tts_voice_target) {
                bvi_tts_voice_target.forEach((item, index) => {
                    bvi_tts_text_id = 'bvi-tts-text-id-' + index;
                    item.innerHTML =
                        '<div class="bvi-tts-text ' +
                        bvi_tts_text_id +
                        '">' +
                        item.innerHTML +
                        '</div>';

                    const d = document.createElement('div');
                    d.innerHTML =
                        '<div class="bvi-tts-link bvi-tts-link-id-' +
                        index +
                        '" data-bvi-tts-class-text=".' +
                        bvi_tts_text_id +
                        '" data-bvi-tts-link-id=".bvi-tts-link-id-' +
                        index +
                        '">\n' +
                        '<a href="#" onclick="return false" class="bvi-tts-play bvi-link">Воспроизвести</a>\n' +
                        '<a href="#" onclick="return false" class="bvi-tts-pause bvi-link disabled">Пауза</i></a>\n' +
                        '<a href="#" onclick="return false" class="bvi-tts-resume bvi-link disabled">Продолжить</i></a>\n' +
                        '<a href="#" onclick="return false" class="bvi-tts-stop bvi-link disabled">Стоп</i></a>\n' +
                        '</div>';
                    item.insertBefore(d, item.firstChild);
                });
            }

            const stripHtml = (html: string) => {
                const tmp = document.createElement('DIV');
                tmp.innerHTML = html;
                return tmp.textContent || tmp.innerText || '';
            };

            document
                .querySelectorAll('.bvi-tts-link')
                .forEach((i: HTMLElement) => (i.style.display = 'block'));
            document.querySelectorAll('.bvi-tts-play').forEach((i) =>
                i.addEventListener('click', () => {
                    bvi_tts_synth.cancel();
                    const bvi_tts_class =
                        i.parentElement && i.parentElement.dataset.bviTtsClassText;
                    const bvi_tts_links_id =
                        i.parentElement && i.parentElement.dataset.bviTtsLinkId;
                    const bvi_tts_class_node =
                        bvi_tts_class && document.querySelector(bvi_tts_class);
                    const bvi_tts_class_text =
                        bvi_tts_class_node && stripHtml(bvi_tts_class_node.innerHTML);

                    if (bvi_tts_class_text) {
                        bvi_tts_speak(bvi_tts_class_text);
                    }

                    document
                        .querySelectorAll('.bvi-tts-play')
                        .forEach((i) => i.classList.remove('disabled'));
                    document
                        .querySelectorAll('.bvi-tts-pause')
                        .forEach((i) => i.classList.add('disabled'));
                    document
                        .querySelectorAll('.bvi-tts-resume')
                        .forEach((i) => i.classList.add('disabled'));
                    document
                        .querySelectorAll('.bvi-tts-stop')
                        .forEach((i) => i.classList.add('disabled'));
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-play')
                        .forEach((i) => i.classList.add('disabled'));
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-pause')
                        .forEach((i) => i.classList.remove('disabled'));
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-stop')
                        .forEach((i) => i.classList.remove('disabled'));

                    return false;
                })
            );

            document.querySelectorAll('.bvi-tts-resume').forEach((i) =>
                i.addEventListener('click', () => {
                    const bvi_tts_links_id =
                        i.parentElement && i.parentElement.dataset.bviTtsLinkId;
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-pause')
                        .forEach((i) => i.classList.remove('disabled'));
                    i.classList.add('disabled');
                    bvi_tts_synth.resume();
                    return false;
                })
            );

            document.querySelectorAll('.bvi-tts-pause').forEach((i) =>
                i.addEventListener('click', () => {
                    const bvi_tts_links_id =
                        i.parentElement && i.parentElement.dataset.bviTtsLinkId;
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-resume')
                        .forEach((i) => i.classList.remove('disabled'));
                    i.classList.add('disabled');
                    bvi_tts_synth.pause();
                    return false;
                })
            );

            document.querySelectorAll('.bvi-tts-stop').forEach((i) =>
                i.addEventListener('click', () => {
                    bvi_tts_synth.cancel();
                    const bvi_tts_links_id =
                        i.parentElement && i.parentElement.dataset.bviTtsLinkId;
                    i.classList.add('disabled');
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-play')
                        .forEach((i) => i.classList.remove('disabled'));
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-pause')
                        .forEach((i) => i.classList.add('disabled'));
                    document
                        .querySelectorAll(bvi_tts_links_id + ' .bvi-tts-resume')
                        .forEach((i) => i.classList.add('disabled'));
                    return false;
                })
            );
        } else {
            document.querySelectorAll('.bvi-tts-link').forEach((i) => i.remove());
            document.querySelectorAll('.bvi-tts-text').forEach((i) => (i.outerHTML = i.innerHTML));
        }
    };

    const bvi_click = () => {
        document
            .querySelectorAll('#bvi-panel-close, .bvi-panel-close, #bvi-toggler-close')
            .forEach((i) =>
                i.addEventListener('click', () => {
                    bvi_tts_speak('Обычная версия сайта');
                    document.querySelector('#bvi-opened').style.display = 'flex';

                    if (Cookies.get('bvi-reload') === 'true') {
                        document.location.reload();
                    }

                    const html = document.querySelector('html');
                    if (html) {
                        html.setAttribute('class', '');
                    }

                    document.querySelectorAll('.bvi-body *').forEach((b: HTMLElement) => {
                        const background_image = b.style.backgroundImage;
                        const pattern =
                            background_image &&
                            background_image
                                .replace(/.*\s?url\([\'\"]?/, '')
                                .replace(/[\'\"]?\).*/, '');
                        if (pattern != 'none') {
                            if (versionIE == 11 || versionIE == 10 || versionIE == 9) {
                                const data_bvi_img_original =
                                    b.getAttribute('data-bvi-background-image-original') || pattern;
                                b.style.backgroundImage = 'url(' + data_bvi_img_original + ')';
                                b.classList.remove('bvi-background-image');
                            }
                        }
                    });

                    document.querySelectorAll('img').forEach((b: HTMLElement) => {
                        b.style.display = 'block';
                        // document.querySelectorAll('div.bvi-img').forEach((c) => c.remove());
                        b.classList.remove('bvi-background-image');
                        if (versionIE == 11 || versionIE == 10 || versionIE == 9) {
                            const data_bvi_img_original =
                                b.getAttribute('data-bvi-img-original') || b.getAttribute('src');
                            if (data_bvi_img_original) {
                                b.setAttribute('src', data_bvi_img_original);
                            }
                        }
                    });

                    document.querySelectorAll('svg.bvi-img').forEach((svg) => {
                        svg.style.display = 'block';
                    });

                    document.querySelectorAll('div.bvi-img').forEach((div) => {
                        if (div.hasAttribute('data-img-bvi')) {
                            div.style.background = div.getAttribute('data-img-bvi');
                        }
                    });
                    document.querySelectorAll('a.bvi-img').forEach((element, index) => {
                        if (element.hasAttribute('data-img-bvi')) {
                            element.style.background = element.getAttribute('data-img-bvi');
                        }
                    });

                    Cookies.remove('bvi-panel-active', { path: '/' });
                    Cookies.remove('bvi-font-size', { path: '/' });
                    Cookies.remove('bvi-theme', { path: '/' });
                    Cookies.remove('bvi-images', { path: '/' });
                    Cookies.remove('bvi-line-height', { path: '/' });
                    Cookies.remove('bvi-letter-spacing', { path: '/' });
                    Cookies.remove('bvi-tts', { path: '/' });
                    Cookies.remove('bvi-font-family', { path: '/' });
                    Cookies.remove('bvi-panel-hide', { path: '/' });
                    Cookies.remove('bvi-flash-iframe', { path: '/' });
                    Cookies.remove('bvi-reload', { path: '/' });

                    active();
                    return false;
                })
            );

        document.querySelectorAll('#bvi-panel-hide, #bvi-toggler-menu-hide').forEach((i) =>
            i.addEventListener('click', () => {
                document.querySelectorAll('.bvi-panel, .bvi-link-top').forEach((b: HTMLElement) => {
                    if (b.style.display === 'block') {
                        b.style.display = 'none';
                    } else {
                        b.style.display = 'block';
                    }
                });
                set('data-bvi-panel-hide', 'bvi-panel-hide', true);
                active();
                bvi_tts_speak('Панель скрыта');
                return false;
            })
        );

        document.querySelectorAll('#bvi-panel-show').forEach((i) =>
            i.addEventListener('click', () => {
                document.querySelectorAll('.bvi-panel, .bvi-link-top').forEach((b: HTMLElement) => {
                    if (b.style.display === 'block') {
                        b.style.display = 'none';
                    } else {
                        b.style.display = 'block';
                    }
                });
                set('data-bvi-panel-hide', 'bvi-panel-hide', false);
                active();
                bvi_tts_speak('Панель открыта');
                return false;
            })
        );

        document.querySelectorAll('#bvi-setting').forEach((i) => {
            i.replaceWith(i.cloneNode(true)); // убирает все предыдущие обработчики
        });
        document.querySelectorAll('#bvi-setting').forEach((i) =>
            i.addEventListener('click', () => {
                document.querySelectorAll('.bvi-setting-menu').forEach((b: HTMLElement) => {
                    if (b.style.display === 'block') {
                        b.style.display = 'none';
                    } else {
                        b.style.display = 'block';
                    }
                });
                i.classList.toggle('active');
                bvi_tts_speak('Дополнительные настройки');
                return false;
            })
        );

        document.querySelectorAll('#bvi-toggler').forEach((i) => {
            i.replaceWith(i.cloneNode(true)); // убирает все предыдущие обработчики
        });
        document.querySelectorAll('#bvi-toggler').forEach((i) =>
            i.addEventListener('click', () => {
                document.querySelectorAll('.bvi-panel-container').forEach((b: HTMLElement) => {
                    if (b.style.display === 'block') {
                        b.style.display = 'none';
                    } else {
                        b.style.display = 'block';
                    }
                });
                i.classList.toggle('active');
                bvi_tts_speak('Меню');
                return false;
            })
        );

        document.querySelectorAll('#bvi-setting-close').forEach((i) =>
            i.addEventListener('click', () => {
                document.querySelectorAll('.bvi-setting-menu').forEach((b: HTMLElement) => {
                    if (b.style.display === 'block') {
                        b.style.display = 'none';
                    } else {
                        b.style.display = 'block';
                    }
                });
                const bviSetting = document.querySelector('#bvi-setting');
                if (bviSetting) {
                    bviSetting.classList.toggle('active');
                }
                bvi_tts_speak('Дополнительные настройки закрыты');
                return false;
            })
        );

        const siblings = (node: Element, children: HTMLCollection) => {
            const siblingList = [];
            for (let n = children.length - 1; n >= 0; n--) {
                if (children[n] != node) {
                    siblingList.push(children[n]);
                }
            }
            return siblingList;
        };

        document.querySelectorAll('#bvi-font-size-less').forEach((i) =>
            i.addEventListener('click', () => {
                const bviFrontSize = Cookies.get('bvi-font-size');
                const size = bviFrontSize && parseFloat(bviFrontSize) - 1;
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                const bviFontSize = document.querySelector('#bvi-font-size');
                if (bviFontSize) {
                    bviFontSize.innerHTML = size + '';
                }
                if (size != 0) {
                    set('data-bvi-size', 'bvi-font-size', size);
                    bvi_tts_speak('Размер шрифта уменьшен');
                }
                return false;
            })
        );

        document.querySelectorAll('#bvi-font-size-more').forEach((i) =>
            i.addEventListener('click', () => {
                const bviFrontSize = Cookies.get('bvi-font-size');
                const size = bviFrontSize && parseFloat(bviFrontSize) + 1;
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                const bviFontSize = document.querySelector('#bvi-font-size');
                if (bviFontSize) {
                    bviFontSize.innerHTML = size + '';
                }
                if (size != 40) {
                    set('data-bvi-size', 'bvi-font-size', size);
                    bvi_tts_speak('Размер шрифта увеличен');
                }
                return false;
            })
        );

        document.querySelectorAll('#bvi-theme-white').forEach((i) =>
            i.addEventListener('click', () => {
                document.querySelectorAll('.ant-select-dropdown').forEach((dropdown) => {
                    dropdown.classList.add('bvi-theme-white');
                });
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-theme', 'bvi-theme', 'white');
                const html = document.querySelector('html');
                if (html) {
                    html.setAttribute('class', '');
                    html.classList.add('bvi-theme-white');
                }
                bvi_tts_speak('Цвет сайта черным по белому');
                return false;
            })
        );

        document.querySelectorAll('#bvi-theme-black').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-theme', 'bvi-theme', 'black');
                const html = document.querySelector('html');
                if (html) {
                    html.setAttribute('class', '');
                    html.classList.add('bvi-theme-black');
                }
                bvi_tts_speak('Цвет сайта белым по черному');
                return false;
            })
        );

        document.querySelectorAll('#bvi-theme-blue').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-theme', 'bvi-theme', 'blue');
                const html = document.querySelector('html');
                if (html) {
                    html.setAttribute('class', '');
                    html.classList.add('bvi-theme-blue');
                }
                bvi_tts_speak('Цвет сайта тёмно-синим по голубому');
                return false;
            })
        );

        document.querySelectorAll('#bvi-theme-brown').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-theme', 'bvi-theme', 'brown');
                const html = document.querySelector('html');
                if (html) {
                    html.setAttribute('class', '');
                    html.classList.add('bvi-theme-brown');
                }
                bvi_tts_speak('Цвет сайта коричневым по бежевому');
                return false;
            })
        );

        document.querySelectorAll('#bvi-theme-green').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-theme', 'bvi-theme', 'green');
                const html = document.querySelector('html');
                if (html) {
                    html.setAttribute('class', '');
                    html.classList.add('bvi-theme-green');
                }
                bvi_tts_speak('Цвет сайта зеленым по тёмно-коричневому');
                return false;
            })
        );

        let enabledImageOff = true;
        let enabledImageGrayscale = true;
        document.querySelectorAll('#bvi-images-grayscale').forEach((i) =>
            i.addEventListener('click', () => {
                if (enabledImageGrayscale) {
                    enabledImageOff = true;
                    i.classList.add('active');
                    if (i.parentElement) {
                        siblings(i, i.parentElement.children).forEach((b) =>
                            b.classList.remove('active')
                        );
                    }
                    set('data-bvi-images', 'bvi-images', 'grayscale');
                    bvi_tts_speak('Изображения чёрно-белые');
                }
                enabledImageGrayscale = false;
            })
        );

        document.querySelectorAll('#bvi-images-true').forEach((i) =>
            i.addEventListener('click', () => {
                enabledImageOff = true;
                enabledImageGrayscale = true;
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-images', 'bvi-images', true);
                bvi_tts_speak('Изображения включены');
                return false;
            })
        );

        const elements = document.querySelectorAll('#bvi-images-false');
        const elementArray = [...elements];
        elementArray.forEach((i) => {
            i.addEventListener('click', () => {
                if (enabledImageOff) {
                    i.classList.add('active');
                    if (i.parentElement) {
                        siblings(i, i.parentElement.children).forEach((b) =>
                            b.classList.remove('active')
                        );
                    }
                    set('data-bvi-images', 'bvi-images', false);
                    bvi_tts_speak('Изображения выключены');
                }
                enabledImageOff = false;
                enabledImageGrayscale = true;
            });
        });

        document.querySelectorAll('#bvi-line-height-normal').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-line-height', 'bvi-line-height', 'normal');
                bvi_tts_speak('Междустрочный интервал cтандартный');
                return false;
            })
        );

        document.querySelectorAll('#bvi-line-height-average').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-line-height', 'bvi-line-height', 'average');
                bvi_tts_speak('Междустрочный интервал средний');
                return false;
            })
        );

        document.querySelectorAll('#bvi-line-height-big').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-line-height', 'bvi-line-height', 'big');
                bvi_tts_speak('Междустрочный интервал большой');
                return false;
            })
        );

        document.querySelectorAll('#bvi-letter-spacing-normal').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-letter-spacing', 'bvi-letter-spacing', 'normal');
                bvi_tts_speak('Межбуквенный интервал одинарный');
                return false;
            })
        );

        document.querySelectorAll('#bvi-letter-spacing-average').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-letter-spacing', 'bvi-letter-spacing', 'average');
                bvi_tts_speak('Межбуквенный интервал полуторный');
                return false;
            })
        );

        document.querySelectorAll('#bvi-letter-spacing-big').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-letter-spacing', 'bvi-letter-spacing', 'big');
                bvi_tts_speak('Межбуквенный интервал двойной');
                return false;
            })
        );

        document.querySelectorAll('#bvi-font-family-arial').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-font-family', 'bvi-font-family', 'arial');
                bvi_tts_speak('Шрифт без засечек');
                return false;
            })
        );

        document.querySelectorAll('#bvi-font-family-times').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-font-family', 'bvi-font-family', 'times');
                bvi_tts_speak('Шрифт с засечками');
                return false;
            })
        );

        document.querySelectorAll('#bvi-flash-iframe-true').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-flash-iframe', 'bvi-flash-iframe', true);
                bvi_tts_speak('Включить встроенные элементы');
                return false;
            })
        );

        document.querySelectorAll('#bvi-flash-iframe-false').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-flash-iframe', 'bvi-flash-iframe', false);
                bvi_tts_speak('Выключить встроенные элементы');
                return false;
            })
        );

        document.querySelectorAll('#bvi-tts-true').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-tts', 'bvi-tts', true);
                bvi_tts_speak('Синтез речи включён');
                bvi_tts_player();
                return false;
            })
        );

        document.querySelectorAll('#bvi-tts-false').forEach((i) =>
            i.addEventListener('click', () => {
                i.classList.add('active');
                if (i.parentElement) {
                    siblings(i, i.parentElement.children).forEach((b) =>
                        b.classList.remove('active')
                    );
                }
                set('data-bvi-tts', 'bvi-tts', false);
                bvi_tts_speak('Синтез речи выключён');
                bvi_tts_player();
                return false;
            })
        );

        document.querySelectorAll('#bvi-settings-default').forEach((i) =>
            i.addEventListener('click', () => {
                const bviClassCookie = document.querySelector(
                    '#bvi-theme-' + Cookies.get('bvi-theme')
                );
                const bviImagesCookie = document.querySelector(
                    '#bvi-images-' + Cookies.get('bvi-images')
                );
                const bviLineHeightCookie = document.querySelector(
                    '#bvi-line-height-' + Cookies.get('bvi-line-height')
                );
                const bviLetterSpacingCookie = document.querySelector(
                    '#bvi-letter-spacing-' + Cookies.get('bvi-letter-spacing')
                );
                const bvFontFamilyCookie = document.querySelector(
                    '#bvi-font-family-' + Cookies.get('bvi-font-family')
                );
                const bvFlashIframeCookie = document.querySelector(
                    '#bvi-flash-iframe-' + Cookies.get('bvi-flash-iframe')
                );
                const bviTTSCookie = document.querySelector('#bvi-tts-' + Cookies.get('bvi-tts'));

                if (bviClassCookie) {
                    bviClassCookie.classList.remove('active');
                }
                if (bviImagesCookie) {
                    bviImagesCookie.classList.remove('active');
                }
                if (bviLineHeightCookie) {
                    bviLineHeightCookie.classList.remove('active');
                }
                if (bviLetterSpacingCookie) {
                    bviLetterSpacingCookie.classList.remove('active');
                }
                if (bvFontFamilyCookie) {
                    bvFontFamilyCookie.classList.remove('active');
                }
                if (bvFlashIframeCookie) {
                    bvFlashIframeCookie.classList.remove('active');
                }
                if (bviTTSCookie) {
                    bviTTSCookie.classList.remove('active');
                }

                const bviClassDefault = document.querySelector(
                    '#bvi-theme-' + default_setting.bvi_theme
                );
                const bviImagesDefault = document.querySelector(
                    '#bvi-images-' + default_setting.bvi_images
                );
                const bviLineHeightDefault = document.querySelector(
                    '#bvi-line-height-' + default_setting.bvi_line_height
                );
                const bviLetterSpacingDefault = document.querySelector(
                    '#bvi-letter-spacing-' + default_setting.bvi_letter_spacing
                );
                const bvFontFamilyDefault = document.querySelector(
                    '#bvi-font-family-' + default_setting.bvi_font
                );
                const bvFlashIframeDefault = document.querySelector(
                    '#bvi-flash-iframe-' + default_setting.bvi_flash_iframe
                );
                const bviTTSDefault = document.querySelector('#bvi-tts-' + default_setting.bvi_tts);
                const bviFontSize = document.querySelector('#bvi-font-size');

                if (bviClassDefault) {
                    bviClassDefault.classList.add('active');
                }
                if (bviImagesDefault) {
                    bviImagesDefault.classList.add('active');
                }
                if (bviLineHeightDefault) {
                    bviLineHeightDefault.classList.add('active');
                }
                if (bviLetterSpacingDefault) {
                    bviLetterSpacingDefault.classList.add('active');
                }
                if (bvFontFamilyDefault) {
                    bvFontFamilyDefault.classList.add('active');
                }
                if (bvFlashIframeDefault) {
                    bvFlashIframeDefault.classList.add('active');
                }
                if (bviTTSDefault) {
                    bviTTSDefault.classList.add('active');
                }
                if (bviFontSize) {
                    bviFontSize.innerHTML = default_setting.bvi_font_size + '';
                }

                set('data-bvi-size', 'bvi-font-size', default_setting.bvi_font_size);
                set('data-bvi-theme', 'bvi-theme', default_setting.bvi_theme);
                set('data-bvi-images', 'bvi-images', default_setting.bvi_images);
                set('data-bvi-line-height', 'bvi-line-height', default_setting.bvi_line_height);
                set(
                    'data-bvi-letter-spacing',
                    'bvi-letter-spacing',
                    default_setting.bvi_letter_spacing
                );
                set('data-bvi-font-family', 'bvi-font-family', default_setting.bvi_font);
                set('data-bvi-flash-iframe', 'bvi-flash-iframe', default_setting.bvi_flash_iframe);
                set('data-bvi-tts', 'bvi-tts', default_setting.bvi_tts);
                bvi_tts_speak('Настройки по умолчанию');
                bvi_tts_player();
                return false;
            })
        );
    };

    const set_active_link = () => {
        const bviClassCookie = document.querySelector('#bvi-theme-' + Cookies.get('bvi-theme'));
        const bviImagesCookie = document.querySelector('#bvi-images-' + Cookies.get('bvi-images'));
        const bviLineHeightCookie = document.querySelector(
            '#bvi-line-height-' + Cookies.get('bvi-line-height')
        );
        const bviLetterSpacingCookie = document.querySelector(
            '#bvi-letter-spacing-' + Cookies.get('bvi-letter-spacing')
        );
        const bvFontFamilyCookie = document.querySelector(
            '#bvi-font-family-' + Cookies.get('bvi-font-family')
        );
        const bvFlashIframeCookie = document.querySelector(
            '#bvi-flash-iframe-' + Cookies.get('bvi-flash-iframe')
        );
        const bviTTSCookie = document.querySelector('#bvi-tts-' + Cookies.get('bvi-tts'));

        if (bviClassCookie) {
            bviClassCookie.classList.add('active');
        }
        if (bviImagesCookie) {
            bviImagesCookie.classList.add('active');
        }
        if (bviLineHeightCookie) {
            bviLineHeightCookie.classList.add('active');
        }
        if (bviLetterSpacingCookie) {
            bviLetterSpacingCookie.classList.add('active');
        }
        if (bvFontFamilyCookie) {
            bvFontFamilyCookie.classList.add('active');
        }
        if (bvFlashIframeCookie) {
            bvFlashIframeCookie.classList.add('active');
        }
        if (bviTTSCookie) {
            bviTTSCookie.classList.add('active');
        }
    };

    const get = () => {
        if (
            typeof Cookies.get('bvi-font-size') === 'undefined' ||
            typeof Cookies.get('bvi-theme') === 'undefined' ||
            typeof Cookies.get('bvi-images') === 'undefined' ||
            typeof Cookies.get('bvi-line-height') === 'undefined' ||
            typeof Cookies.get('bvi-letter-spacing') === 'undefined' ||
            typeof Cookies.get('bvi-tts') === 'undefined' ||
            typeof Cookies.get('bvi-font-family') === 'undefined' ||
            typeof Cookies.get('bvi-panel-hide') === 'undefined' ||
            typeof Cookies.get('bvi-flash-iframe') === 'undefined' ||
            typeof Cookies.get('bvi-reload') === 'undefined' ||
            typeof Cookies.get('bvi-fixed') === 'undefined'
        ) {
            Cookies.set('bvi-font-size', String(default_setting.bvi_font_size), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-theme', String(default_setting.bvi_theme), { path: '/', expires: 1 });
            Cookies.set('bvi-images', String(default_setting.bvi_images), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-line-height', String(default_setting.bvi_line_height), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-letter-spacing', String(default_setting.bvi_letter_spacing), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-tts', String(default_setting.bvi_tts), { path: '/', expires: 1 });
            Cookies.set('bvi-font-family', String(default_setting.bvi_font), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-panel-hide', String(default_setting.bvi_hide), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-flash-iframe', String(default_setting.bvi_flash_iframe), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-reload', String(default_setting.bvi_reload), {
                path: '/',
                expires: 1,
            });
            Cookies.set('bvi-fixed', String(default_setting.bvi_fixed), { path: '/', expires: 1 });
        }

        document.querySelectorAll('.bvi-body').forEach((i) => {
            const bviPanel = Cookies.get('bvi-panel-hide');
            const bviSize = Cookies.get('bvi-font-size');
            const bviTheme = Cookies.get('bvi-theme');
            const bviImages = Cookies.get('bvi-images');
            const bviLineHeight = Cookies.get('bvi-line-height');
            const bviLetterSpacing = Cookies.get('bvi-letter-spacing');
            const bviFontFamily = Cookies.get('bvi-font-family');
            const bviFlashIframe = Cookies.get('bvi-flash-iframe');
            const bviReload = Cookies.get('bvi-reload');
            const bviTts = Cookies.get('bvi-tts');
            const bviFixed = Cookies.get('bvi-fixed');

            if (bviPanel) {
                i.setAttribute('data-bvi-panel-hide', bviPanel);
            }
            if (bviSize) {
                i.setAttribute('data-bvi-size', bviSize);
            }
            if (bviTheme) {
                i.setAttribute('data-bvi-theme', bviTheme);
            }
            if (bviImages) {
                i.setAttribute('data-bvi-images', bviImages);
            }
            if (bviLineHeight) {
                i.setAttribute('data-bvi-line-height', bviLineHeight);
            }
            if (bviLetterSpacing) {
                i.setAttribute('data-bvi-letter-spacing', bviLetterSpacing);
            }
            if (bviFontFamily) {
                i.setAttribute('data-bvi-font-family', bviFontFamily);
            }
            if (bviFlashIframe) {
                i.setAttribute('data-bvi-flash-iframe', bviFlashIframe);
            }
            if (bviReload) {
                i.setAttribute('data-bvi-reload', bviReload);
            }
            if (bviTts) {
                i.setAttribute('data-bvi-tts', bviTts);
            }
            if (bviFixed) {
                i.setAttribute('data-bvi-fixed', bviFixed);
            }
        });

        const bviFontSize = document.querySelector('#bvi-font-size');
        const bviFontSizeCookie = Cookies.get('bvi-font-size');
        if (bviFontSize && bviFontSizeCookie) {
            bviFontSize.innerHTML = bviFontSizeCookie;
        }

        const bvi_panel = Cookies.get('bvi-panel-hide');

        if (bvi_panel === 'false' || typeof bvi_panel === 'undefined') {
            document
                .querySelectorAll('.bvi-panel')
                .forEach((i: HTMLElement) => (i.style.display = 'block'));
            document
                .querySelectorAll('.bvi-link-top')
                .forEach((i: HTMLElement) => (i.style.display = 'none'));
        } else {
            document
                .querySelectorAll('.bvi-panel')
                .forEach((i: HTMLElement) => (i.style.display = 'none'));
            document
                .querySelectorAll('.bvi-link-top')
                .forEach((i: HTMLElement) => (i.style.display = 'block'));
        }
    };

    const get_image = () => {
        const bvi_images = Cookies.get('bvi-images');

        document.querySelectorAll('img, svg').forEach((element) => {
            element.classList.add('bvi-img');
        });

        document.querySelectorAll('div').forEach((div) => {
            const backgroundStyle = getComputedStyle(div).backgroundImage;
            if (backgroundStyle !== 'none') {
                div.classList.add('bvi-img');
            }
        });

        document.querySelectorAll('a').forEach((el) => {
            const backgroundStyle = getComputedStyle(el).backgroundImage;
            if (backgroundStyle !== 'none') {
                el.classList.add('bvi-img');
            }
        });

        if (bvi_images === 'true') {
            document.querySelectorAll('img').forEach((i) => {
                i.style.display = 'block';
                // document.querySelectorAll('div.bvi-img').forEach((b) => b.remove());
                if (versionIE == 11 || versionIE == 10 || versionIE == 9) {
                    const data_bvi_img_original =
                        i.getAttribute('data-bvi-img-original') || i.getAttribute('src');
                    if (data_bvi_img_original) {
                        i.setAttribute('src', data_bvi_img_original);
                    }
                }
            });

            document.querySelectorAll('.bvi-body *').forEach((i) => {
                const computedStyle = getComputedStyle(i);
                const background_image = computedStyle.backgroundImage;
                const pattern =
                    background_image &&
                    background_image.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
                if (pattern !== 'none') {
                    if (versionIE == 11 || versionIE == 10 || versionIE == 9) {
                        const r =
                            '^(https?|http)://[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]';
                        if (pattern && pattern.match(r)) {
                            const data_bvi_img_original =
                                i.getAttribute('data-bvi-background-image-original') || pattern;
                            i.style.backgroundImage = 'url(' + data_bvi_img_original + ')';
                        }
                    }
                }
            });

            document.querySelectorAll('svg.bvi-img').forEach((svg) => {
                svg.style.display = 'block';
            });

            document.querySelectorAll('div.bvi-img').forEach((div) => {
                if (div.hasAttribute('data-img-bvi')) {
                    div.style.background = div.getAttribute('data-img-bvi');
                    div.style.backgroundBlendMode = 'unset';
                }
            });
            document.querySelectorAll('a.bvi-img').forEach((element, index) => {
                if (element.hasAttribute('data-img-bvi')) {
                    element.style.background = element.getAttribute('data-img-bvi');
                    element.style.backgroundBlendMode = 'unset';
                }
            });
        }

        if (bvi_images === 'false') {
            document.querySelectorAll('a.bvi-img').forEach((element) => {
                const backgroundStyle = getComputedStyle(element).backgroundImage;
                if (!element.hasAttribute('data-img-bvi')) {
                    if (backgroundStyle !== 'none') {
                        element.setAttribute('data-img-bvi', element.style.backgroundImage);
                        element.style.backgroundImage = 'none';
                        element.style.backgroundBlendMode = 'unset';
                    }
                } else {
                    element.style.backgroundImage = 'none';
                    element.style.backgroundBlendMode = 'unset';
                }
            });

            document.querySelectorAll('svg.bvi-img').forEach((svg) => (svg.style.display = 'none'));

            document.querySelectorAll('div.bvi-img').forEach((div) => {
                const backgroundStyle = getComputedStyle(div).backgroundImage;
                if (!div.hasAttribute('data-img-bvi')) {
                    if (backgroundStyle !== 'none') {
                        div.setAttribute('data-img-bvi', div.style.backgroundImage);
                        div.style.backgroundImage = 'none';
                        div.style.backgroundBlendMode = 'unset';
                    }
                } else {
                    div.style.backgroundImage = 'none';
                    div.style.backgroundBlendMode = 'unset';
                }
            });

            document.querySelectorAll('img').forEach((element) => {
                element.style.display = 'none';
            });
        }

        if (bvi_images === 'grayscale') {
            document.querySelectorAll('img').forEach((i: HTMLElement) => {
                i.style.display = 'block';
                // document.querySelectorAll('div.bvi-img').forEach((b) => b.remove());

                if (versionIE == 11 || versionIE == 10 || versionIE == 9) {
                    const src = i.getAttribute('src');
                    if (src) {
                        i.setAttribute('data-bvi-img-original', src);
                        if (location.hostname === extractHostname(src)) {
                            const srcGray = grayscale(src);
                            i.setAttribute('src', srcGray);
                        } else {
                            return false;
                        }
                    }
                }
                return true;
            });

            document.querySelectorAll('.bvi-body *').forEach((i: HTMLElement) => {
                const background_image = i.style.backgroundImage;
                const pattern =
                    background_image &&
                    background_image.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
                if (pattern != 'none') {
                    if (versionIE == 11 || versionIE == 10 || versionIE == 9) {
                        const r =
                            '^(https?|http)://[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]';
                        if (pattern && pattern.match(r)) {
                            const src_pattern = grayscale(pattern);
                            i.setAttribute('data-bvi-background-image-original', pattern);
                            i.style.backgroundImage = 'url(' + src_pattern + ') !important';
                        }
                    }
                }
            });

            // document.querySelectorAll('a.bvi-img').forEach((element) => {
            //     const backgroundStyle = getComputedStyle(element).backgroundImage;
            //     const linearGradientRegex = /linear-gradient/;
            //     if (backgroundStyle !== 'none' && !linearGradientRegex.test(backgroundStyle)) {
            //         element.setAttribute('data-img-bvi', backgroundStyle);
            //         element.style.backgroundImage = `linear-gradient(#000, #000), ${backgroundStyle}`;
            //         element.style.backgroundSize = 'cover';
            //         element.style.backgroundBlendMode = 'saturation';
            //     } else {
            //         element.style.backgroundImage = `linear-gradient(#000, #000), ${element.getAttribute(
            //             'data-img-bvi'
            //         )}`;
            //         element.style.backgroundSize = 'cover';
            //         element.style.backgroundBlendMode = 'saturation';
            //     }
            // });

            // document.querySelectorAll('svg.bvi-img').forEach((svg) => (svg.style.display = 'none'));

            // document.querySelectorAll('div.bvi-img').forEach((div) => {
            //     const backgroundStyle = getComputedStyle(div).backgroundImage;
            //     const linearGradientRegex = /linear-gradient/;
            //     if (backgroundStyle !== 'none' && !linearGradientRegex.test(backgroundStyle)) {
            //         div.setAttribute('data-img-bvi', backgroundStyle);
            //         div.style.backgroundImage = `linear-gradient(#000, #000), ${backgroundStyle}`;
            //         div.style.backgroundSize = 'cover';
            //         div.style.backgroundBlendMode = 'saturation';
            //     } else {
            //         div.style.backgroundImage = `linear-gradient(#000, #000), ${div.getAttribute(
            //             'data-img-bvi'
            //         )}`;
            //         div.style.backgroundSize = 'cover';
            //         div.style.backgroundBlendMode = 'saturation';
            //     }
            // });

            document.querySelectorAll('svg.bvi-img').forEach((svg) => {
                svg.style.display = 'block';
            });

            document.querySelectorAll('div.bvi-img').forEach((div) => {
                if (div.hasAttribute('data-img-bvi')) {
                    div.style.background = div.getAttribute('data-img-bvi');
                    div.style.backgroundBlendMode = 'unset';
                }
            });
            document.querySelectorAll('a.bvi-img').forEach((element, index) => {
                if (element.hasAttribute('data-img-bvi')) {
                    element.style.background = element.getAttribute('data-img-bvi');
                    element.style.backgroundBlendMode = 'unset';
                }
            });
        }
    };

    const extractHostname = (url: string) => {
        let hostname;
        if (url.indexOf('//') > -1) {
            [, , hostname] = url.split('/');
        } else {
            [hostname] = url.split('/');
        }
        [hostname] = hostname.split(':');
        [hostname] = hostname.split('?');

        return hostname;
    };

    const grayscale = (src: string) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const imgObj = new Image();
        imgObj.src = src;
        canvas.width = imgObj.naturalWidth || imgObj.offsetWidth || imgObj.width;
        canvas.height = imgObj.naturalHeight || imgObj.offsetHeight || imgObj.height;
        if (ctx) {
            ctx.drawImage(imgObj, 0, 0);
            const imgPixels = ctx.getImageData(0, 0, canvas.width, canvas.height);

            for (let y = 0; y < imgPixels.height; y++) {
                for (let x = 0; x < imgPixels.width; x++) {
                    const i = y * 4 * imgPixels.width + x * 4;
                    const avg =
                        (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
                    imgPixels.data[i] = avg;
                    imgPixels.data[i + 1] = avg;
                    imgPixels.data[i + 2] = avg;
                }
            }
            ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
        }

        return canvas.toDataURL();
    };

    const active = () => {
        if (versionIE == 8 || versionIE == 7 || versionIE == 6 || versionIE == 5) {
            // console.log('Bvi console: Браузер не поддерживается.');
            alert(confirm('Браузер не поддерживается.'));
        } else {
            if (Cookies.get('bvi-panel-active') === 'true') {
                // document.querySelectorAll(selector).forEach(i => {
                //   const normalVersion = document.createElement('a');
                //   normalVersion.setAttribute('href', '#');
                //   normalVersion.setAttribute('class', 'bvi-panel-close');
                //   normalVersion.setAttribute('title', 'Обычная версия сайта');
                //   normalVersion.innerHTML = 'Обычная версия сайта';
                //
                //   i.classList.add('bvi-hide');
                //   if (i.parentNode) {
                //     i.parentNode.appendChild(normalVersion);
                //   }
                // });

                panel();
                setTimeout(() => {
                    bvi_tts_player();
                }, 1000);

                bvi_click();
                set_active_link();
                if (!bvi_tts_support_browser) {
                    Cookies.set('bvi-tts', 'false', { path: '/', expires: 1 });
                    document.querySelectorAll('#bvi-tts-true').forEach((i) => i.remove());
                    document.querySelectorAll('#bvi-tts-false').forEach((i) => i.remove());
                }
                document.querySelector('#bvi-opened').style.display = 'none';
            } else {
                bvi_tts_player();
                document.querySelectorAll(selector).forEach((i) => i.classList.remove('bvi-hide'));
                document.querySelectorAll('.bvi-panel-close').forEach((i) => i.remove());
                document.querySelectorAll('.bvi-panel').forEach((i) => i.remove());
                document.querySelectorAll('.bvi-link-top').forEach((i) => i.remove());
                document
                    .querySelectorAll('body > .bvi-body')
                    .forEach((i) => i.classList.remove('bvi-body'));
                document.querySelectorAll('.bvi-tts-link').forEach((i) => i.remove());
                document
                    .querySelectorAll('.bvi-tts-text')
                    .forEach((i) => (i.outerHTML = i.innerHTML));
            }
        }
    };

    const panel = () => {
        const meta = document.createElement('meta');
        meta.setAttribute('name', 'viewport');
        meta.setAttribute('content', 'width=device-width, initial-scale=1, shrink-to-fit=no');

        const head = document.querySelector('head');
        if (head) {
            head.appendChild(meta);
        }
        const body = document.querySelector('#root');
        if (body && !body.classList.contains('bvi-body')) {
            body.classList.add('bvi-body');
            const bviPanel = document.createElement('div');
            bviPanel.innerHTML = `
            <div class="bvi-panel">
                <div class="bvi-container-fluid">
                    <div class="bvi-row bvi-no-gutters">
                        <div class="bvi-col-12">
                            <div class="bvi-panel-toggler">
                                <a href="#" onclick="return false" id="bvi-toggler" class="bvi-link" title="${localize(
                                    'bvi-menu',
                                    props.translations
                                )}">${localize('bvi-menu', props.translations)}</a>
                                <a href="#" onclick="return false" id="bvi-toggler-close" class="bvi-link" title="${localize(
                                    'bvi-usually',
                                    props.translations
                                )}">${localize('bvi-usually', props.translations)}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bvi-panel-container bvi-container">
                    <div class="bvi-row bvi-no-gutters">
                        <div class="bvi-col-6 bvi-col-sm-6 bvi-col-md-3 bvi-col-lg-3 bvi-col-xl-3 bvi-text-center">
                            <div class="bvi-title">
                                <span id="bvi-font-size"></span> px
                            </div>
                            <a href="#" onclick="return false" id="bvi-font-size-less" class="bvi-link" title="${localize(
                                'bvi-decrease-font',
                                props.translations
                            )}">A -</a>
                            <a href="#" onclick="return false" id="bvi-font-size-more" class="bvi-link" title="${localize(
                                'bvi-increase-font',
                                props.translations
                            )}">A +</a>
                        </div>
                        <div class="bvi-col-6 bvi-col-sm-6 bvi-col-md-3 bvi-col-lg-3 bvi-col-xl-3 bvi-text-center">
                            <div class="bvi-title">${localize(
                                'bvi-colors',
                                props.translations
                            )}</div>
                            <a href="#" onclick="return false" id="bvi-theme-white" class="bvi-link bvi-link-white" title="${localize(
                                'bvi-black',
                                props.translations
                            )}">Ц</a>
                            <a href="#" onclick="return false" id="bvi-theme-black" class="bvi-link bvi-link-black" title="${localize(
                                'bvi-white',
                                props.translations
                            )}" style="color: white !important;">Ц</a>
                            <a href="#" onclick="return false" id="bvi-theme-blue" class="bvi-link bvi-link-blue" title="${localize(
                                'bvi-blue',
                                props.translations
                            )}">Ц</a>
                            <a href="#" onclick="return false" id="bvi-theme-brown" class="bvi-link bvi-link-brown" title="${localize(
                                'bvi-brown',
                                props.translations
                            )}">Ц</a>
                            <a href="#" onclick="return false" id="bvi-theme-green" class="bvi-link bvi-link-green" title="${localize(
                                'bvi-green',
                                props.translations
                            )}" style="color: white !important;">Ц</a>
                        </div>
                        <div class="bvi-col-6 bvi-col-sm-6 bvi-col-md-3 bvi-col-lg-3 bvi-col-xl-2 bvi-text-center">
                            <div class="bvi-title">${localize(
                                'bvi-images',
                                props.translations
                            )}</div>
                            <a href="#" onclick="return false" id="bvi-images-true" class="bvi-link-header img-background" title="${localize(
                                'bvi-images-on',
                                props.translations
                            )}"><i class="bvi-images bvi-images-on bvi-background-image"></i></a>
                            <a href="#" onclick="return false" id="bvi-images-false" class="bvi-link-header img-background" title="${localize(
                                'bvi-images-off',
                                props.translations
                            )}"><i class="bvi-images bvi-images-off bvi-background-image"></i></a>
                            <a href="#" onclick="return false" id="bvi-images-grayscale" class="bvi-link-header img-background" title="${localize(
                                'bvi-images-black-and-white',
                                props.translations
                            )}"><i class="bvi-images bvi-images-adjust bvi-background-image"></i></a>
                        </div>
                        <div class="bvi-col-6 bvi-col-sm-6 bvi-col-md-3 bvi-col-lg-3 bvi-col-xl-4 bvi-text-center">
                            <div class="bvi-title">${localize(
                                'bvi-additional',
                                props.translations
                            )}</div>
                            <a href="#" onclick="return false" id="bvi-setting" class="bvi-link-header" title="${localize(
                                'bvi-settings',
                                props.translations
                            )}">${localize('bvi-settings', props.translations)}</a>
                            <a href="#" onclick="return false" id="bvi-panel-close" class="bvi-link img-background" title="${localize(
                                'bvi-usually',
                                props.translations
                            )}"><i class="bvi-images bvi-images-eye-slash bvi-background-image"></i></a>
                            <a href="#" onclick="return false" id="bvi-panel-hide" class="bvi-link img-background" title="Скрыть панель">
                            <i class="bvi-images bvi-images-minus-square-o bvi-background-image"></i>
                            </a>
                        </div>
                    </div>
                    <div class="bvi-setting-menu bvi-hide-lg">
                        <div class="bvi-row bvi-no-gutters">
                            <div class="bvi-col-sm-12 bvi-col-md-6 bvi-col-lg-4 bvi-col-xl-4 bvi-text-center">
                                <div class="bvi-title">${localize(
                                    'bvi-line-spacing',
                                    props.translations
                                )}</div>
                                <a href="#" onclick="return false" id="bvi-line-height-normal" class="bvi-link-header" title="${localize(
                                    'bvi-line-spacing-standart',
                                    props.translations
                                )}">${localize('bvi-line-standard', props.translations)}</a>
                                <a href="#" onclick="return false" id="bvi-line-height-average" class="bvi-link-header" title="${localize(
                                    'bvi-line-spacing-middle',
                                    props.translations
                                )}">${localize('bvi-line-middle', props.translations)}</a>
                                <a href="#" onclick="return false" id="bvi-line-height-big" class="bvi-link-header" title="${localize(
                                    'bvi-line-spacing-big',
                                    props.translations
                                )}">${localize('bvi-line-big', props.translations)}</a>
                            </div>
                            <div class="bvi-col-sm-12 bvi-col-md-6 bvi-col-lg-5 bvi-col-xl-5 bvi-text-center">
                                <div class="bvi-title">${localize(
                                    'bvi-letter-spacing',
                                    props.translations
                                )}</div>
                                <a href="#" onclick="return false" id="bvi-letter-spacing-normal" class="bvi-link-header" title="${localize(
                                    'bvi-letter-spacing-single',
                                    props.translations
                                )}">${localize('bvi-letter-single', props.translations)}</a>
                                <a href="#" onclick="return false" id="bvi-letter-spacing-average" class="bvi-link-header" title="${localize(
                                    'bvi-letter-spacing-one-and-half',
                                    props.translations
                                )}">${localize('bvi-letter-one-and-half', props.translations)}</a>
                                <a href="#" onclick="return false" id="bvi-letter-spacing-big" class="bvi-link-header" title="${localize(
                                    'bvi-letter-spacing-double',
                                    props.translations
                                )}">${localize('bvi-letter-double', props.translations)}</a>
                            </div>
                            <div class="bvi-col-sm-12 bvi-col-md-6 bvi-col-lg-3 bvi-col-xl-3 bvi-text-center">
                                <div class="bvi-title">${localize(
                                    'bvi-font',
                                    props.translations
                                )}</div>
                                <a href="#" onclick="return false" id="bvi-font-family-arial" class="bvi-link-header" title="${localize(
                                    'bvi-font-without',
                                    props.translations
                                )}">${localize('bvi-font-wtht', props.translations)}</a>
                                <a href="#" onclick="return false" id="bvi-font-family-times" class="bvi-link-header" title="${localize(
                                    'bvi-font-with',
                                    props.translations
                                )}">${localize('bvi-font-wth', props.translations)}</a>
                            </div>
                            <div class="bvi-col-sm-12 bvi-col-md-12 bvi-col-lg-6 bvi-col-xl-6 bvi-text-right">
                                <div class="bvi-title">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#" onclick="return false" id="bvi-panel-show" class="bvi-link bvi-link-top"><i class="bvi-images bvi-images-eye"></i></a>
            `;
            body.insertBefore(bviPanel, body.firstChild);
        }

        if (width >= lg) {
            document
                .querySelectorAll('.bvi-panel-container')
                .forEach((i: HTMLElement) => (i.style.display = 'block'));
        }

        if (width <= lg) {
            document.querySelectorAll('.bvi-panel-container').forEach((i) => {
                i.classList.remove('bvi-container');
                i.classList.add('bvi-container-fluid');
            });
        } else {
            document.querySelectorAll('.bvi-panel-container').forEach((i) => {
                i.classList.remove('bvi-container-fluid');
                i.classList.add('bvi-container');
            });
        }

        document.addEventListener('DOMContentLoaded', function () {
            const scroll =
                window.scrollY !== undefined
                    ? window.scrollY
                    : (document.documentElement || document.body.parentNode || document.body)
                          .scrollTop;

            if (scroll > 99) {
                if (Cookies.get('bvi-fixed') == 'true') {
                    document
                        .querySelectorAll('.bvi-panel')
                        .forEach((i) => i.classList.add('bvi-fixed-top'));
                }
            }
        });

        window.addEventListener('scroll', () => {
            if (document.body.scrollTop >= 99) {
                if (Cookies.get('bvi-fixed') == 'true') {
                    document
                        .querySelectorAll('.bvi-panel')
                        .forEach((i) => i.classList.add('bvi-fixed-top'));
                }
            } else {
                document
                    .querySelectorAll('.bvi-panel')
                    .forEach((i) => i.classList.remove('bvi-fixed-top'));
            }
        });

        get();
        get_image();
    };

    // let checkError;
    if (
        default_setting.bvi_theme == 'white' ||
        default_setting.bvi_theme == 'black' ||
        default_setting.bvi_theme == 'blue' ||
        default_setting.bvi_theme == 'brown' ||
        default_setting.bvi_theme == 'green'
    ) {
        check_bvi_theme = true;
    } else {
        check_bvi_theme = false;
        // checkError = ['bvi_theme'];
    }

    if (default_setting.bvi_font == 'times' || default_setting.bvi_font == 'arial') {
        check_bvi_font = true;
    } else {
        check_bvi_font = false;
        // checkError = ['bvi_font'];
    }

    if (
        default_setting.bvi_letter_spacing == 'normal' ||
        default_setting.bvi_letter_spacing == 'average' ||
        default_setting.bvi_letter_spacing == 'big'
    ) {
        check_bvi_letter_spacing = true;
    } else {
        check_bvi_letter_spacing = false;
        // checkError = ['bvi_letter_spacing'];
    }

    if (
        default_setting.bvi_line_height == 'normal' ||
        default_setting.bvi_line_height == 'average' ||
        default_setting.bvi_line_height == 'big'
    ) {
        check_bvi_line_height = true;
    } else {
        check_bvi_line_height = false;
        // checkError = ['bvi_line_height'];
    }

    if (default_setting.bvi_font_size == 0) {
        check_bvi_font_size = false;
        // checkError = ['bvi_font_size'];
    } else if (default_setting.bvi_font_size <= 40) {
        check_bvi_font_size = true;
    } else {
        check_bvi_font_size = false;
        // checkError = ['bvi_font_size'];
    }

    if (
        default_setting.bvi_images === false ||
        default_setting.bvi_images === true ||
        default_setting.bvi_images === 'grayscale'
    ) {
        check_bvi_images = true;
    } else {
        check_bvi_images = false;
        // checkError = ['bvi_images'];
    }

    if (default_setting.bvi_fixed === false || default_setting.bvi_fixed === true) {
        check_bvi_fixed = true;
    } else {
        check_bvi_fixed = false;
        // checkError = ['bvi_fixed'];
    }

    if (default_setting.bvi_tts === false || default_setting.bvi_tts === true) {
        check_bvi_tts = true;
    } else {
        check_bvi_tts = false;
        // checkError = ['bvi_tts'];
    }

    if (default_setting.bvi_flash_iframe === false || default_setting.bvi_flash_iframe === true) {
        check_bvi_flash_iframe = true;
    } else {
        check_bvi_flash_iframe = false;
        // checkError = ['bvi_flash_iframe'];
    }

    if (default_setting.bvi_hide === false || default_setting.bvi_hide === true) {
        check_bvi_hide = true;
    } else {
        check_bvi_hide = false;
        // checkError = ['bvi_hide'];
    }

    if (
        check_bvi_theme === true &&
        check_bvi_font === true &&
        check_bvi_letter_spacing === true &&
        check_bvi_line_height === true &&
        check_bvi_font_size === true &&
        check_bvi_images === true &&
        check_bvi_fixed === true &&
        check_bvi_flash_iframe === true &&
        check_bvi_tts === true &&
        check_bvi_hide === true
    ) {
        // document.querySelectorAll(selector).forEach(i => {
        //   i.addEventListener('click', () => {
        //     Cookies.set('bvi-panel-active', 'true', { path: '/', expires: 1 });
        //     active();
        //     bvi_tts_speak('Версия сайта для слабовидящих');
        //     return false;
        //   });
        // });

        document.addEventListener('click', (e) => {
            const target = e.target && (e.target as HTMLElement);
            if (
                target &&
                target.closest('button') &&
                target.closest('button').classList.contains('bvi-open')
            ) {
                Cookies.set('bvi-panel-active', 'true', { path: '/', expires: 1 });
                (document.querySelector('#bvi-opened') as HTMLDivElement).style.display = 'none';
                active();
                bvi_tts_speak('Версия сайта для слабовидящих');
            }
        });

        const bviOpen = document.querySelector('.bvi-open');
        if (bviOpen) {
            bviOpen.addEventListener('keypress', (e: any) => {
                if (e.key === 'Enter') {
                    Cookies.set('bvi-panel-active', 'true', { path: '/', expires: 1 });
                    active();
                    (document.querySelector('#bvi-opened') as HTMLDivElement).style.display =
                        'none';
                    bvi_tts_speak('Версия сайта для слабовидящих');
                }
            });
        }

        active();
    } else {
        // console.log('Bvi console: Неправильный параметр - [' + checkError + ']');
    }
};
export default bvi;
